<form [formGroup]="orgForm">
	<div class="card-block">
		<div class="card-title">
			<span class="card-title-label" translate>organization.card.details.identity</span>
		</div>
		<div class="organization-card-infos-block">
			<div class="organization-card-info">
				<span class="organization-card-info-label label-updated-styles"
					translate>datacenter-filter.organization-id</span>
				<span class="organization-card-info-value">{{organization?.id || UNDERSCORE}}</span>
			</div>
			<div class="organization-card-info" *ngIf="!editMode">
				<span class="organization-card-info-label label-updated-styles" translate>organization.card.identity.name</span>
				<span class="organization-card-info-value organization-card-info-text-corpo-color">{{organization?.name || UNDERSCORE}}</span>
			</div>
			<mat-form-field *ngIf="editMode">
				<mat-label translate>datacenter-filter.organization-id</mat-label>
				<input class="input-styles" formControlName="name" matInput type="text" spellcheck="false"
					autocomplete="off" required>
				<mat-icon matSuffix class="icon-styles" svgIcon="md:edit"></mat-icon>
				<mat-error *ngIf="orgForm.controls['name'].dirty && orgForm.controls['name'].invalid">
					<span class="organization-card-info-text-corpo-color-red">Please enter valid
						Name</span>
				</mat-error>
			</mat-form-field>
			<div class="organization-card-info" *ngIf="!editMode">
				<span class="organization-card-info-label label-updated-styles" translate>organization.card.identity.vat</span>
				<span class="organization-card-info-value">{{organization?.vatNumber || UNDERSCORE}}</span>
			</div>
			<mat-form-field *ngIf="editMode">
				<mat-label translate>organization.card.identity.vat</mat-label>
				<input class="input-styles" formControlName="vatNumber" matInput type="text"
					spellcheck="false" autocomplete="off" required>
				<mat-icon matSuffix class="icon-styles" svgIcon="md:edit"></mat-icon>
				<mat-error *ngIf="orgForm.controls['vatNumber'].invalid">
					<span class="organization-card-info-text-corpo-color-red">Please enter valid
						Vat Number</span>
				</mat-error>
			</mat-form-field>
			<div class="organization-card-info">
				<span class="organization-card-info-label label-updated-styles"
					translate>organization.card.identity.suppliers</span>
				<span class="organization-card-info-value">{{supplier?.join() || UNDERSCORE}}</span>
			</div>
			<div class="organization-card-info" *ngIf="!editMode">
				<span class="organization-card-info-label label-updated-styles"
					translate>organization.card.identity.country</span>
				<span class="organization-card-info-value">{{organization?.address?.countryCodeDescription || UNDERSCORE}}</span>
			</div>
			<mat-form-field *ngIf="editMode">
				<mat-label translate>organization.card.identity.country</mat-label>
				<mat-select class="input-styles" formControlName="country">
					<mat-option *ngFor="let country of countries" [value]="country">
						{{ country.countryDescription }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<div class="organization-card-info" *ngIf="!editMode">
				<span class="organization-card-info-label label-updated-styles"
					translate>organization.card.identity.address</span>
				<span class="organization-card-info-value">{{organization?.address?.address || UNDERSCORE}}</span>
			</div>
			<mat-form-field *ngIf="editMode">
				<mat-label translate>organization.card.identity.address</mat-label>
				<input class="input-styles" formControlName="address" matInput type="text"
					spellcheck="false" autocomplete="off">
				<mat-icon matSuffix class="icon-styles" svgIcon="md:edit"></mat-icon>
				<mat-error *ngIf="orgForm.controls['address'].dirty && orgForm.controls['address'].invalid">
					<span class="organization-card-info-text-corpo-color-red">Please enter valid
						Address</span>
				</mat-error>
			</mat-form-field>
			<div class="organization-card-info" *ngIf="!editMode">
				<span class="organization-card-info-label label-updated-styles"
					translate>organization.card.identity.postCode</span>
				<span class="organization-card-info-value">{{organization?.address?.zipCode || UNDERSCORE}}</span>
			</div>
			<mat-form-field *ngIf="editMode">
				<mat-label translate>organization.card.identity.postCode</mat-label>
				<input class="input-styles" formControlName="postCode" matInput type="text"
					spellcheck="false" autocomplete="off">
				<mat-icon matSuffix class="icon-styles" svgIcon="md:edit"></mat-icon>
				<mat-error *ngIf="orgForm.controls['postCode'].dirty && orgForm.controls['postCode'].invalid">
					<span class="organization-card-info-text-corpo-color-red">Please enter valid
						PostCode</span>
				</mat-error>
			</mat-form-field>
			<div class="organization-card-info" *ngIf="!editMode">
				<span class="organization-card-info-label label-updated-styles" translate>organization.card.identity.city</span>
				<span class="organization-card-info-value">{{organization?.address?.city?.toUpperCase() || UNDERSCORE}}</span>
			</div>
			<mat-form-field *ngIf="editMode">
				<mat-label translate>organization.card.identity.city</mat-label>
				<input class="input-styles" formControlName="city" matInput type="text" spellcheck="false"
					autocomplete="off">
				<mat-icon matSuffix class="icon-styles" svgIcon="md:edit"></mat-icon>
				<mat-error *ngIf="orgForm.controls['city'].dirty && orgForm.controls['city'].invalid">
					<span class="organization-card-info-text-corpo-color-red">Please enter valid
						City</span>
				</mat-error>
			</mat-form-field>
			<div class="organization-card-info" *ngIf="!editMode">
				<span class="organization-card-info-label label-updated-styles" translate>organization.card.identity.state</span>
				<span class="organization-card-info-value">{{organization?.address?.county || UNDERSCORE}}</span>
			</div>
			<mat-form-field *ngIf="editMode">
				<mat-label translate>organization.card.identity.state</mat-label>
				<input class="input-styles" formControlName="stateOrCounty" matInput type="text"
					spellcheck="false" autocomplete="off">
				<mat-icon matSuffix class="icon-styles" svgIcon="md:edit"></mat-icon>
				<mat-error
					*ngIf="orgForm.controls['stateOrCounty'].dirty && orgForm.controls['stateOrCounty'].invalid">
					<span class="organization-card-info-text-corpo-color-red">Please enter valid
						State Or Country</span>
				</mat-error>
			</mat-form-field>
		</div>
	</div>
</form>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>